import Vue from 'vue';
import Vuex from 'vuex';
import { setToken, getToken, removeToken } from "../utils/token";
import { login, loginOut } from "../api/userMG";

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    name: '',
    userId: '',
    token: getToken(),
    roleName: '',
    pd: '',
    username:''
  },
  getters: {
    collapse(state) {
      return state.collapse
    }
  },
  mutations: {
    SET_ROLE_NAME: (state, roleName) => {
      state.roleName = roleName
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PD: (state, pd) => {
      state.pd = pd
    },
    SET_USERNAME: (state, username) =>{
      state.username=username
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          // console.log(userInfo)
          if (response.data) {
            const data = response.data
            // commit('SET_ROLE_NAME', data.roles[0].slug)
            commit('SET_TOKEN', data.token)
            commit('SET_NAME', data.user.username)
            commit('SET_USER_ID', data.user.id)
            commit('SET_PD', userInfo.password)
            commit('SET_USERNAME', data.user.name)
            localStorage.setItem('token', data.token)
            localStorage.setItem('userId', data.user.id)
            // localStorage.setItem('roleName', data.roles[0].slug)
            localStorage.setItem('username', data.user.username)
            localStorage.setItem('pd', userInfo.password)
            localStorage.setItem('name', data.user.name)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        let param ={
          token:localStorage.getItem('token')
        }
        loginOut(param).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          commit('SET_ROLE_NAME', '')
          commit('SET_PD', '')
          commit('SET_DEPTID', '')
          commit('SET_USERNAME', '')
          localStorage.setItem('token', '')
          localStorage.setItem('username', '')
          localStorage.setItem('userId', '')
          localStorage.setItem('roleName', '')
          localStorage.setItem('pd', '')
          localStorage.setItem('name', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js